import React from 'react';
import { buildClassnames } from '../../../utils';
import { FlexDefaultProps, FlexProps } from '../types';
import flexColStyles from './FlexCol.module.scss';
import flexStyles from '../Flex.module.scss';

export const FLEX_COL_DEFAULT_PROPS: FlexDefaultProps = {
  alignItems: 'stretch',
  justifyContent: 'flex-start',
  gap: 'sm',
  flexWrap: 'wrap',
  flexGrow: 0,
};

export const FlexCol = React.forwardRef<HTMLDivElement, FlexProps>(
  (
    {
      alignItems = FLEX_COL_DEFAULT_PROPS.alignItems,
      justifyContent = FLEX_COL_DEFAULT_PROPS.justifyContent,
      gap = FLEX_COL_DEFAULT_PROPS.gap,
      flexWrap = FLEX_COL_DEFAULT_PROPS.flexWrap,
      flexGrow = FLEX_COL_DEFAULT_PROPS.flexGrow,
      className,
      style,
      children,
      ...rest
    },
    ref,
  ) => {
    const cssClasses = [
      flexColStyles.flexCol,
      flexStyles[`alignItems-${alignItems}`],
      flexStyles[`justifyContent-${justifyContent}`],
      flexStyles[`gap-${gap}`],
      flexStyles[`flexWrap-${flexWrap}`],
      className,
    ];

    return (
      <div
        className={buildClassnames(cssClasses)}
        style={{ flexGrow, ...style }}
        ref={ref}
        {...rest}
      >
        {children}
      </div>
    );
  },
);
